export default __webpack_public_path__ + "static/media/post4.bab6310d.png";